export const TypesVistoria = {
    PREPARAVISTORIA: "PREPARAVISTORIA",
    // BUSCARISO: "BUSCARISO",
    ALTERARDIGITOCTR: "ALTERARDIGITOCTR",
    ALTERARPAYLOADNET: "ALTERARPAYLOADNET",
    ALTERARTARA: "ALTERARTARA",
    ALTERAREXCEDENTECOMPRIMENTOCHECK: "ALTERAREXCEDENTECOMPRIMENTOCHECK",
    ALTERAREXCEDENTEALTURACHECK: "ALTERAREXCEDENTEALTURACHECK",
    ALTERAREXCEDENTELARGURACHECK: "ALTERAREXCEDENTELARGURACHECK",
    ALTERAREXCEDENTECOMPRIMENTOEMCM: "ALTERAREXCEDENTECOMPRIMENTOEMCM",
    ALTERAREXCEDENTEALTURAEMCM: "ALTERAREXCEDENTEALTURAEMCM",
    ALTERAREXCEDENTELARGURADIREITAEMCM: "ALTERAREXCEDENTELARGURADIREITAEMCM",
    ALTERAREXCEDENTELARGURAESQUERDAEMCM: "ALTERAREXCEDENTELARGURAESQUERDAEMCM",
    ATUALIZARNODES: "ATUALIZARNODES",
    GRAVAR: "GRAVAR",
    RESET: "RESET"
}

const INITIAL = {
    // $id: null,
    Sucesso: false,
    Mensagem: "",
    PassagemContainerID: 0,
    PassagemContainerNumero: "",
    PassagemContainerCondicao: "",
    LocalID: 0,
    Tara: 0,
    PayLoad: 0,
    PayLoadObrigatorio: false,
    EstaNoPadraoISO: false,
    EstaComEGMCI: false,
    TemAvariaTeto: false,
    TemTAC: false,
    TemPermissaoEdicaoAvariaComTAC: false,
    HabilitaExcedente: false,
    PodeEditarDigito: true,
    Nodes: [],
    CodigoISO: {},
    Excedente: {},
    ListarLacres: {},
    Gravar: false
}

export default function preparaVistoriaReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesVistoria.PREPARAVISTORIA:
            return {
                ...state,
                // $id: action.payload.$id,
                Sucesso: action.payload.Sucesso,
                Mensagem: action.payload.Mensagem,
                PassagemContainerID: action.payload.PassagemContainerID,
                PassagemContainerNumero: action.payload.PassagemContainerNumero,
                PassagemContainerCondicao: action.payload.PassagemContainerCondicao,
                LocalID: action.payload.LocalID,
                Tara: action.payload.Tara,
                PayLoad: action.payload.PayLoad,
                PayLoadObrigatorio: action.payload.PayLoadObrigatorio,
                EstaNoPadraoISO: action.payload.EstaNoPadraoISO,
                EstaComEGMCI: action.payload.EstaComEGMCI,
                TemAvariaTeto: action.payload.TemAvariaTeto,
                TemTAC: action.payload.TemTAC,
                TemPermissaoEdicaoAvariaComTAC: action.payload.TemPermissaoEdicaoAvariaComTAC,
                HabilitaExcedente: action.payload.HabilitaExcedente,
                PodeEditarDigito: action.payload.PodeEditarDigito,
                Nodes: action.payload.Nodes,
                CodigoISO: action.payload.CodigoISO,
                Excedente: action.payload.Excedente,
                ListarLacres: action.payload.ListarLacres
            };
        // case TypesVistoria.BUSCARISO:
        //     return {
        //         ...state,
        //         CodigoISO: {
        //             $id: action.payload.$id,
        //             Sucesso: action.payload.Sucesso,
        //             Mensagem: action.payload.Mensagem,
        //             ISO: action.payload.ISO,
        //             ISODetalhes: action.payload.ISODetalhes,
        //             TipoContainer: action.payload.TipoContainer,
        //             TaraMaxima: action.payload.TaraMaxima,
        //             TaraMinima: action.payload.TaraMinima,
        //             TaraMaximaAviso: action.payload.TaraMaximaAviso,
        //             HabilitaExcedenteCasoCheio: action.payload.HabilitaExcedenteCasoCheio
        //         },
        //     };
        case TypesVistoria.ALTERARDIGITOCTR:
            return {
                ...state,
                PassagemContainerNumero: action.payload.PassagemContainerNumero
            };
        case TypesVistoria.ALTERARPAYLOADNET:
            return {
                ...state,
                PayLoad: action.payload.PayLoad
            };
        case TypesVistoria.ALTERARTARA:
            return {
                ...state,
                Tara: action.payload.Tara
            };
        case TypesVistoria.ALTERAREXCEDENTECOMPRIMENTOCHECK:
            return {
                ...state,
                Excedente: {
                    ...state.Excedente,
                    ExcedenteComprimento: action.payload.ExcedenteComprimento
                }
            };
        case TypesVistoria.ALTERAREXCEDENTEALTURACHECK:
            return {
                ...state,
                Excedente: {
                    ...state.Excedente,
                    ExcedenteAltura: action.payload.ExcedenteAltura
                }
            };
        case TypesVistoria.ALTERAREXCEDENTELARGURACHECK:
            return {
                ...state,
                Excedente: {
                    ...state.Excedente,
                    ExcedenteLargura: action.payload.ExcedenteLargura
                }
            };
        case TypesVistoria.ALTERAREXCEDENTECOMPRIMENTOEMCM:
            return {
                ...state,
                Excedente: {
                    ...state.Excedente,
                    ExcedenteComprimentoEmCm: action.payload.ExcedenteComprimentoEmCm
                }
            };
        case TypesVistoria.ALTERAREXCEDENTEALTURAEMCM:
            return {
                ...state,
                Excedente: {
                    ...state.Excedente,
                    ExcedenteAlturaEmCm: action.payload.ExcedenteAlturaEmCm
                }
            };
        case TypesVistoria.ALTERAREXCEDENTELARGURADIREITAEMCM:
            return {
                ...state,
                Excedente: {
                    ...state.Excedente,
                    ExcedenteLarguraDireitaEmCm: action.payload.ExcedenteLarguraDireitaEmCm
                }
            };
        case TypesVistoria.ALTERAREXCEDENTELARGURAESQUERDAEMCM:
            return {
                ...state,
                Excedente: {
                    ...state.Excedente,
                    ExcedenteLarguraEsquerdaEmCm: action.payload.ExcedenteLarguraEsquerdaEmCm
                }
            };
        case TypesVistoria.ATUALIZARNODES:
            return {
                ...state,
                Nodes: action.payload
            };
        case TypesVistoria.GRAVAR:
            return {
                ...state,
                Gravar: action.payload.Gravar
            };
        case TypesVistoria.RESET:
            return INITIAL;

        default:
            return state;
    }
}


export const VistoriaActions = {
    preparaVistoria,
    //buscarISO,
    alterarDigitoCTR,
    alterarPayLoadNet,
    alterarTara,
    alterarExcedenteComprimentoCheck,
    alterarExcedenteAlturaCheck,
    alterarExcedenteLarguraCheck,
    alterarExcedenteComprimentoEmCm,
    alterarExcedenteAlturaEmCm,
    alterarExcedenteLarguraDireitaEmCm,
    alterarExcedenteLarguraEsquerdaEmCm,
    atualizarNodes,
    gravar,
    resetState
}

function preparaVistoria(dadosPreparaVistoria) {
    return {
        type: TypesVistoria.PREPARAVISTORIA,
        payload: dadosPreparaVistoria
    }
}

function atualizarNodes(dados) {
    return {
        type: TypesVistoria.ATUALIZARNODES,
        payload: dados
    }
}

// function buscarISO(dadosISO) {
//     return {
//         type: TypesVistoria.BUSCARISO,
//         payload: dadosISO
//     }
// }

function alterarDigitoCTR(digito, container) {
    if (container.length > 12) {
        let novoNumeroContainer = container.substr(0, 13) + digito
        return {
            type: TypesVistoria.ALTERARDIGITOCTR,
            payload: { PassagemContainerNumero: novoNumeroContainer }
        }
    }
}

function gravar(gravar) {
    return {
        type: TypesVistoria.GRAVAR,
        payload: { Gravar: gravar }
    }
}

function alterarPayLoadNet(payload) {
    return {
        type: TypesVistoria.ALTERARPAYLOADNET,
        payload: { PayLoad: payload }
    }
}

function alterarTara(payload) {
    return {
        type: TypesVistoria.ALTERARTARA,
        payload: { Tara: payload }
    }
}

function alterarExcedenteComprimentoCheck(checked) {
    return {
        type: TypesVistoria.ALTERAREXCEDENTECOMPRIMENTOCHECK,
        payload: { ExcedenteComprimento: checked }
    }
}

function alterarExcedenteAlturaCheck(checked) {
    return {
        type: TypesVistoria.ALTERAREXCEDENTEALTURACHECK,
        payload: { ExcedenteAltura: checked }
    }
}

function alterarExcedenteLarguraCheck(checked) {
    return {
        type: TypesVistoria.ALTERAREXCEDENTELARGURACHECK,
        payload: { ExcedenteLargura: checked }
    }
}

function alterarExcedenteComprimentoEmCm(value) {
    return {
        type: TypesVistoria.ALTERAREXCEDENTECOMPRIMENTOEMCM,
        payload: { ExcedenteComprimentoEmCm: value }
    }
}

function alterarExcedenteAlturaEmCm(value) {
    return {
        type: TypesVistoria.ALTERAREXCEDENTEALTURAEMCM,
        payload: { ExcedenteAlturaEmCm: value }
    }
}

function alterarExcedenteLarguraDireitaEmCm(value) {
    return {
        type: TypesVistoria.ALTERAREXCEDENTELARGURADIREITAEMCM,
        payload: { ExcedenteLarguraDireitaEmCm: value }
    }
}

function alterarExcedenteLarguraEsquerdaEmCm(value) {
    return {
        type: TypesVistoria.ALTERAREXCEDENTELARGURAESQUERDAEMCM,
        payload: { ExcedenteLarguraEsquerdaEmCm: value }
    }
}

function resetState() {
    return { type: "RESET" }
}